import { render, staticRenderFns } from "./RomaActivity.vue?vue&type=template&id=7e813456"
import script from "./RomaActivity.vue?vue&type=script&lang=ts"
export * from "./RomaActivity.vue?vue&type=script&lang=ts"
import style0 from "./RomaActivity.vue?vue&type=style&index=0&id=7e813456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports